export const decimalCoordinateToDegreesMinutesSeconds = (decimalCoordinates: number) => {
  const degrees = Math.floor(decimalCoordinates)
  const minutes = Math.floor((decimalCoordinates - degrees) * 60)
  const seconds = Math.floor((decimalCoordinates - degrees - minutes / 60) * 3600)
  return `${degrees}° ${minutes}' ${seconds}''`
}

export const formatCoordinatesMultiline = (coord: { lat: number; lng: number }) => {
  let text = ""
  let latitudeLetter = "N"
  if (coord.lat < 0) {
    latitudeLetter = "S"
  }
  let longitudeLetter = "E"
  if (coord.lng < 0) {
    longitudeLetter = "W"
  }
  text += "\n"
  text += `• ${latitudeLetter} ${decimalCoordinateToDegreesMinutesSeconds(
    coord.lat,
  )} (${coord.lat.toFixed(6)})\n`
  text += `• ${longitudeLetter} ${decimalCoordinateToDegreesMinutesSeconds(
    coord.lng,
  )} (${coord.lng.toFixed(6)})`
  return text
}
